import React from 'react';

const PolicyContext = React.createContext('policy');

export default PolicyContext;
